import { useTranslation } from 'react-i18next'
import { Bell } from 'lucide-react'
import { Button } from '@/components/shadcn/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/shadcn/tooltip'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'
import { useGetApiUsersCurrentNotificationsCount } from '@/api/generated/user/user'
import { NotificationPopoverContent } from './NotificationPopoverContent'

/** Bell with unread badge; opens the notification list. */
export function NotificationsButton() {
  const { t } = useTranslation('header')

  const { data: countData } = useGetApiUsersCurrentNotificationsCount()
  const unreadCount: number = (countData as any)?.data ?? countData ?? 0
  const hasUnread = unreadCount > 0

  return (
    <Popover>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button variant="ghost" size="icon" className="relative h-9 w-9 rounded-full">
              <Bell className="h-5! w-5!" />
              {hasUnread && (
                <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-0.5 text-[9px] font-bold text-primary-foreground leading-none">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{t('notifications.tooltip')}</TooltipContent>
      </Tooltip>
      <PopoverContent align="end" className="w-80 p-0">
        <NotificationPopoverContent />
      </PopoverContent>
    </Popover>
  )
}
